import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IDocumentState } from "@/store/modules/document/state";
import { IRootState } from "@/store";
import { DocumentMutations } from "@/store/modules/document/mutations";
import { filemanagerApi } from "@/config/http-filemanager";
import { AuthGetters } from "@/store/modules/auth";
import { accountKey } from "@/utils/accountSession";

export enum DocumentActions {
  FETCH_DATA_PROVIDER = "GET_DATA_PROVIDER_DOCUMENT",
  FETCH_ONE = "GET_ONE_DOCUMENT",
  FETCH_UPDATE_ONE = "GET_UPDATE_ONE_DOCUMENT",
  FETCH_ALL = "GET_ALL_DOCUMENT",
  CREATE = "CREATE_DOCUMENT",
  UPDATE = "UPDATE_DOCUMENT",
  DELETE = "DELETE_DOCUMENT",
  DOWNLOAD = "DOWNLOAD_DOCUMENT",
  HISTORY = "HISTORY_DOCUMENT",
  SET_FAVOURITE = "SET_FAVOURITE",
}

let listRequestSequence = 0;
export const actions: ActionTree<IDocumentState, IRootState> = {
  async [DocumentActions.FETCH_DATA_PROVIDER]({ commit, rootGetters }, filter) {
    const sequence = ++listRequestSequence;
    const account = accountKey(rootGetters[AuthGetters.GET_USER_IDENTITY]);
    const result = await baseApi.get("/documents/document/list", {
      params: filter,
    });
    if (
      sequence !== listRequestSequence ||
      account !== accountKey(rootGetters[AuthGetters.GET_USER_IDENTITY])
    )
      return;
    commit(DocumentMutations.SET_LAZY_DATA, result.data.data);
    return result.data.data;
  },
  async [DocumentActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/documents/document/view/${id}`);
      commit(DocumentMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch company one error: ", error);
    }
  },
  async [DocumentActions.FETCH_UPDATE_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(
        "/documents/document/sub-data/document-update-info",
        { params: { id: id } }
      );
      commit(DocumentMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch company one error: ", error);
    }
  },
  async [DocumentActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/documents/document/create", data)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log("document create error: ", error);
          reject(error.response);
        });
    });
  },
  async [DocumentActions.UPDATE]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/documents/document/update/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log("document update error: ", error);
          reject(error.response);
        });
    });
  },
  async [DocumentActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/documents/document/delete/${id}`);
    } catch (error) {
      console.log("document delete error: ", error);
    }
  },
  async [DocumentActions.DOWNLOAD]({ commit }, id: string) {
    return new Promise((resolve, reject) => {
      filemanagerApi
        .get("/download", {
          params: { file: id },
          responseType: "blob",
        })
        .then((response) => {
          commit(DocumentMutations.SET_FILE, response.data);
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async [DocumentActions.SET_FAVOURITE]({ commit }, id: string) {
    try {
      await baseApi.post(`/documents/document/add-to-favorite`, {
        documentId: id,
      });
    } catch (error) {
      console.log("document delete error: ", error);
    }
  },
  /*getConstructors(): Promise<any> {

        return  baseApi.get('/documents/document/sub-data/constructors')
    }

    getConstructorInfo(id: any): Promise<any> {
        return baseApi.get('/documents/document/sub-data/constructor-info', {params:{id: id}})
    }

    getNomenclatures(): Promise<any> {
        return baseApi.get('/documents/document/sub-data/nomenclatures')
    }

    getProcessUserFilter(data: any): Promise<any> {
        return baseApi.post('/documents/document/sub-data/process-user-filter', data)
    }

    getOneDocumentUpdateInfo(id: any): Promise<any> {
        return baseApi.get('/documents/document/sub-data/document-update-info',{ params:{id: id}})
    }

    uploadDocument(file: any): Promise<any> {
        return filemanagerApi.post('/upload', file,{headers:{'Content-Type': 'multipart/form-data' }})
    }

    getFilesInfo(file: any): Promise<any> {
        return filemanagerApi.post('/files-info', file)
    }

    returnDocument(id: any): Promise<any> {
        return baseApi.get(`/documents/document/return/${id}`)
    }

    sendForExecution(id: any): Promise<any> {
        return baseApi.get(`/documents/document/send-for-execution/${id}`)
    }

    getConstructorFilter(): Promise<any> {
        return baseApi.get(`/documents/document/filter-data/constructors`)
    }*/
};
